import styled from 'styled-components';
import TopContainer from '../TopContainer';

const OtherContainer = styled(TopContainer)`
  padding-top: 38px;
  padding-bottom: 44px;
`;

export default OtherContainer;
